import React, { useEffect, useState, useCallback } from 'react';
import { css } from '@emotion/css';
import ApplicationContainer from '../../../../shared/state/containers/ApplicationContainer';
import AppliedApplicationTemplateContainer from '../../../../shared/state/containers/AppliedApplicationTemplateContainer';
import OrganizationContainer from '../../../../shared/state/containers/OrganizationContainer';
import TemplateFormSectionModel from '../../../../shared/models/templating/api/TemplateFormSectionModel';
import TemplateFormFieldValueModel from '../../../../shared/models/templating/api/TemplateFormFieldValueModel';
import Loader from '../../../../shared/components/general/Loader';
import FullPagePanel from '../../../../shared/components/structure/Panels/FullPagePanel';
import BackButton from '../../../../shared/components/general/BackButton';
import HeaderTitleView from '../../../../shared/components/structure/HeaderTitleView';
import PanelContainer from '../../../../shared/components/structure/Panels/PanelContainer';
import PageError from '../../../../shared/components/general/PageError';
import { combineSections, findActiveSectionIndex, CombinedSection, getNextSection, getPreviousSection, getPageCount as utilGetPageCount, getCurrentPageNumber as utilGetCurrentPageNumber, getTemplateSectionsOnly } from '../../../../shared/utils/sectionUtils';
import { color_shades_dark, color_shades_lighter, color_variants_main_bg } from '../../../../shared/constants/colors';
import PanelHeaderContainer from '../../../../shared/components/structure/Panels/PanelHeaderContainer';
import ScrollablePanelBody from '../../../../shared/components/structure/ScrollablePanelBody';
import AppliedAppTemplateSectionMenu from '../../../../shared/scenes/applicationAppliedTemplateManager/components/AppliedAppTemplateSectionMenu';
import CollapsedMenuPanel from '../../../../shared/components/structure/CollapsedMenuPanel';
import CollapsingPanel from '../../../../shared/components/structure/Panels/CollapsingPanel';
import ExpandedMenuPanel from '../../../../shared/components/structure/ExpandedMenuPanel';
import UpdateAppliedAppTemplateForm from './UpdateAppliedAppTemplateForm';
import SparkTemplateFormSectionModel from '../../../../shared/models/templating/api/SparkTemplateFormSectionModel';
import styled from '@emotion/styled';
import { breakpoint_small } from '../../../../shared/constants/breakpoints';
import ApplicationEnvironmentsContainer from '../../../../shared/state/containers/ApplicationEnvironmentsContainer';
import ConfirmationDialog from '../../../../shared/components/structure/ConfirmationDialog';
import WarningConfirmation from '../../../../shared/components/general/WarningConfirmation';
import _, { set } from 'lodash';
import ApplicationAnalyticsFacetContainer from '../../../../shared/state/containers/ApplicationAnalyticsFacetContainer';
import ApplicationAnalytics from '../../../../shared/scenes/applicationAnalytics';
import TelephonyDeploymentContainer from '../../../../shared/hooks/TelephonyDeploymentContainer';
import TelephonyDeploymentRequest from '../../../../shared/models/telephonyDeployment/TelephonyDeploymentRequest';
import SparkTelephonyDetailsForm from './SparkTelephonyDetailsForm';
import { female1Voice, female2Voice, female3Voice, female4Voice, male1Voice, male2Voice, male3Voice, male4Voice } from '../../../../shared/constants/sparkConstants/voices';
import HeaderSeparator from '../../../../shared/components/structure/Panels/HeaderSeparator';
import ProfileMenu from '../../../../shared/scenes/profileMenu';
import { TabPanel } from 'react-tabs';
import FullPageTabbedPanel from '../../../../shared/components/structure/Panels/FullPageTabbedPanel';
import ContentCollapsingSection from '../../../../shared/components/structure/ContentCollapsingSection';
import SettingsCard from '../../../../shared/components/structure/SettingsCard';
import EmptyView from '../../../../shared/scenes/applicationModules/components/EmptyView';
import { TelephonyDeploymentResponse } from '../../../../shared/models/telephonyDeployment/TelephonyDeploymentResponse';
import SparkTelephonyDeploymentForm from './SparkTelephonyDeploymentForm';
import { voiceOptions } from '../../../../shared/constants/sparkConstants/voiceOptions';
import { v4 as uuidv4 } from 'uuid';
import AppliedAppTemplateReviewForm from './AppliedAppTemplateReviewForm';
import TemplateConfigurationContainer from '../../../../shared/state/containers/TemplateConfigurationContainer';
import { getOfferTextTemplateConfigId, getRespondTemplateConfigId, getTransferTemplateConfigId } from '../../../../shared/constants/sparkConstants/customRequestModuleIds';
import SparkDeploymentContainer from '../../../../shared/hooks/SparkDeploymentContainer';
import { formatPhoneNumber } from '../basicOrganizationApplications/components/ApplicationItem';
import MenuManagement from './MenuManagement';
import { Route } from 'react-router';
import ApplicationMenuItemManager from '../../../../shared/scenes/applicationMenuItem';
import useIsMobile from '../../../../shared/hooks/UseIsMobile';
import MenuSyncContainer from '../../../../shared/hooks/MenuSyncContainer';
import StatusIndicator from '../../../../shared/components/general/StatusIndicator';
import MenuContainer from '../../../../shared/hooks/MenuContainer';
import MediaContainer from '../../../../shared/state/containers/MediaContainer';
import { AutoGenerateFormFieldResponsesForm } from './autoGenerateFormField/AutoGenerateFormFieldResponsesForm';
import Button from '../../../../shared/components/general/Button';
import OutboundCall from './outboundCall';
import { OutboundCallFeatureFlagId, FoodOrderingFeatureFlagId, HealthcareSchedulingFeatureFlagId } from '../../../../shared/constants/featureFlagIds';
import SelectField from '../../../../shared/components/forms/SelectField';
import ApplicationModel from '../../../../shared/models/applications/api/ApplicationModel';
import { is } from 'date-fns/locale';
import SonioxContextEditor from '../../../../shared/scenes/applicationSettings/components/telephonyDeployments/SonioxContextEditor';
import { getSonioxContextValidationError, normalizeSonioxContextJson } from '../../../../shared/scenes/applicationSettings/components/telephonyDeployments/sonioxContextUtils';

const analyticsIcon = require('../../../../shared/content/images/tab-icons/analytics.svg');
const formIcon = require('../../../../shared/content/images/task-checklist-check-white.svg');
const voiceIcon = require('../../../../shared/content/images/tab-icons/voice.svg');
const outboundCallIcon = require('../../../../shared/content/images/tab-icons/phone-arrow-out.svg');
const voiceIconBlue = require('../../../../shared/content/images/tab-icons/voice-blue.svg');
const menuIcon = require('../../../../shared/content/images/tab-icons/menu.svg');

const moveIcon = require('../../../../shared/content/images/move.svg');

interface AppliedTemplateManagerContentProps {
    applicationId: string
    templateConfigurationId?: string
    appContainer: ApplicationContainer
    appliedAppTemplateContainer: AppliedApplicationTemplateContainer
    orgContainer: OrganizationContainer
    history: any
    applicationEnvironmentsContainer: ApplicationEnvironmentsContainer
    facetContainer: ApplicationAnalyticsFacetContainer
    templateConfigContainer: TemplateConfigurationContainer
    appliedAppTemplateId: string
    mediaContainer: MediaContainer
};

export interface AppendedSection {
    id: string
    name: string
    isComplete: boolean
    isSelected: boolean
}

export type ApplicationType = "common" | "location" | null;

const ApplicationManagerContent: React.FC<AppliedTemplateManagerContentProps> = (props) => {
    const [loaded, setLoaded] = useState<boolean>(false);
    const [isLeftExpanded, setIsLeftExpanded] = useState<boolean>(true);
    const [isFinishSelected, setIsFinishSelected] = useState<boolean>(false);
    const [currentSection, setCurrentSection] = useState<SparkTemplateFormSectionModel>(null);
    const [areNoTemplateFormSections, setAreNoTemplateFormSections] = useState<boolean>(false);
    const [combinedFormSections, setCombinedFormSections] = useState<SparkTemplateFormSectionModel[]>([]);
    const [incompleteSections, setIncompleteSections] = useState<TemplateFormSectionModel[]>([]);
    const [closeModalIsOpen, setCloseModalIsOpen] = useState<boolean>(false);
    const [applicationType, setApplicationType] = useState<ApplicationType>();
    const [isLoadingTelephonyDeployments, setIsLoadingTelephonyDeployments] = useState<boolean>(false);
    const [telephonyDeployments, setTelephonyDeployments] = useState<TelephonyDeploymentResponse[]>([]);
    const [isLoadingApplicationType, setIsLoadingApplicationType] = useState<boolean>(true);
    const [telephonyDeploymentSection, setTelephonyDeploymentSection] = useState<AppendedSection>(null);
    const [autoGenerateFormResponsesSection, setAutoGenerateFormResponsesSection] = useState<AppendedSection>(null);
    const [appendedSections, setAppendedSections] = useState<AppendedSection[]>([]);
    const [phoneNumberDeploymentErrorText, setPhoneNumberDeploymentErrorText] = useState<string>("");
    const [tabs, setTabs] = useState<any[]>([]);
    const [importedFormFields, setImportedFormFields] = useState<TemplateFormFieldValueModel[]>([]);
    const [fileImportErrors, setFileImportErrors] = useState<string[]>([]);
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [menuSyncing, setMenuSyncing] = useState<boolean>(false);
    const [selectedMenuCategoryIndex, setSelectedMenuCategoryIndex] = useState(0);
    const [isLoadingAutoGenerateAnswer, setIsLoadingAutoGenerateAnswer] = useState(false);
    const [selectedTelephonyDeploymentNumber, setSelectedTelephonyDeploymentNumber] = useState<string>("");
    const [applicationsList, setApplicationsList] = useState<ApplicationModel[]>([]);
    const [targetApplicationName, setTargetApplicationName] = useState<string>("");
    const [showAdminFields, setShowAdminFields] = useState<boolean>(false);
    const [sectionsToRemove, setSectionsToRemove] = useState<string[]>([]);
    const [fieldValidationErrors, setFieldValidationErrors] = useState<Record<string, boolean>>({});
    const [highlightedFieldId, setHighlightedFieldId] = useState<string | null>(null);
    const [sparkHintsAndTermsJson, setSparkHintsAndTermsJson] = useState<string>('');
    const [sparkHintsAndTermsTouched, setSparkHintsAndTermsTouched] = useState<boolean>(false);
    const [isSavingHintsAndTerms, setIsSavingHintsAndTerms] = useState<boolean>(false);

    const telephonyDeploymentContainer = TelephonyDeploymentContainer.useContainer();
    const trainingContainer = SparkDeploymentContainer.useContainer();
    const menuSyncContainer = MenuSyncContainer.useContainer();
    const menuContainer = MenuContainer.useContainer();
    const isMobile = useIsMobile();

    const handleFieldValidationChange = useCallback((fieldId: string, hasErrors: boolean) => {
        setFieldValidationErrors(prev => ({
            ...prev,
            [fieldId]: hasErrors
        }));
    }, []);

    useEffect(() => {
        initialLoad();
    }, []);

    useEffect(() => {
        if (!loaded) {
            return;
        }
        loadApplicationType();
    }, [loaded, props.appContainer.state.currentApp]);

    useEffect(() => {
        if (!loaded || !appendedSections?.length) {
            return;
        }
        const newAppended = appendedSections.filter(section => !sectionsToRemove.includes(section.id));
        setAppendedSections(newAppended);
    }, [sectionsToRemove])

    useEffect(() => {
        const newMenuSyncing = menuSyncContainer.isApplicationSyncing(props.appContainer?.state?.currentApp?.id);
        if (menuSyncing) {
            if (!newMenuSyncing) {
                menuContainer.getLiveMenu(props.appContainer?.state?.currentApp?.id);
            }
        }
        setMenuSyncing(newMenuSyncing);
    }, [menuSyncContainer.syncingMenus]);

    useEffect(() => {
        trainingContainer.setCurrentOrgId(props.orgContainer.state.currentOrganization.id);
    }, [props?.orgContainer?.state?.currentOrganization?.id]);

    useEffect(() => {
        if (loaded) {
            setSelectedTab(getSelectedIndex())
        }
    }, [props.history.location.pathname, tabs, loaded]);

    useEffect(() => {
        if (sparkHintsAndTermsTouched) {
            return;
        }

        const existingHintsAndTerms = telephonyDeployments.find(deployment => !!deployment.sonioxContextJson?.length)?.sonioxContextJson ?? '';
        setSparkHintsAndTermsJson(existingHintsAndTerms);
    }, [telephonyDeployments, sparkHintsAndTermsTouched]);

    useEffect(() => {
        if (!loaded) return;
        setTabs(getTabs());
    }, [telephonyDeploymentContainer.telephonyDeployments, loaded]);

    useEffect(() => {
        const fetchApplications = async () => {
            const result = await props.appContainer.getApplicationsForOrg(props.orgContainer?.state?.currentOrganization?.id);
            setApplicationsList(result.data)
        }
        if (props.appContainer?.state?.orgApplicationsList?.length === 0) {
            fetchApplications();
        } else {
            setApplicationsList(props.appContainer.state.orgApplicationsList);
        }
    }, []);

    useEffect(() => {
        // this is where we combine all applied template form sections into one form and sort based on priority
        if (!loaded) return;
        const formSections: SparkTemplateFormSectionModel[] = [];
        const orgAppliedTemplates = props.appliedAppTemplateContainer.state.perApplicationAppliedTemplates ?? [];
        if (orgAppliedTemplates.length) {
            const appAppliedTemplates = orgAppliedTemplates.find((template) => template.applicationId === props.applicationId);
            const sortedAppAppliedTemplates = _.sortBy(appAppliedTemplates?.appliedTemplates ?? [], a => a?.createdDate);
            let priority = 0;
            sortedAppAppliedTemplates?.forEach((appliedTemplate) => {
                if (appliedTemplate.templateForm?.templateConfigurationId === getRespondTemplateConfigId()
                    || appliedTemplate.templateForm?.templateConfigurationId === getTransferTemplateConfigId()
                    || appliedTemplate.templateForm?.templateConfigurationId === getOfferTextTemplateConfigId()
                ) {
                    appliedTemplate.templateForm?.templateFormSections?.forEach((section) => {
                        priority += 1;
                        formSections.push(
                            {
                                appliedTemplateId: appliedTemplate.id,
                                section: { ...section, priority: priority, title: appliedTemplate.name, isCustom: true }
                            }
                        );
                    });
                } else {
                    let showTitle = false;
                    if (appliedTemplate.templateForm?.templateFormSections.length > 1) {
                        showTitle = true;
                    }
                    appliedTemplate.templateForm?.templateFormSections?.forEach((section) => {
                        priority += 1;
                        let name = appliedTemplate.name;
                        if (showTitle || !name) {
                            name = section.title;
                        }

                        //we found a duplicate title
                        const otherSectionIndex = formSections.findIndex(form => form.section.title === name);
                        if (otherSectionIndex >= 0) {
                            //set the new title for both the current and the prviouse duplicate
                            const otherSection = formSections[otherSectionIndex];
                            const otherOgSection = appliedTemplate.templateForm?.templateFormSections.find(sec => sec.id === otherSection.section.id);
                            const otherOgAppliedTemplate = sortedAppAppliedTemplates.find(temp => temp.id == otherSection.appliedTemplateId);

                            formSections[otherSectionIndex].section.name = otherOgSection.title + "-" + otherOgAppliedTemplate.name;
                            name = section.title + "-" + appliedTemplate.name;
                        }


                        formSections.push(
                            {
                                appliedTemplateId: appliedTemplate.id,
                                section: { ...section, priority: priority, title: name }
                            }
                        );
                    });
                }
            })
        }
        setCombinedFormSections(formSections);
        if (formSections.length > 0 && !currentSection && !telephonyDeploymentSection && !autoGenerateFormResponsesSection) {
            setCurrentSection(formSections[0]);
        }
    }, [props.appliedAppTemplateContainer.state.appliedTemplates, loaded])

    useEffect(() => {
        if (!loaded || isLoadingApplicationType) return;
        setTelephonyDeployments(telephonyDeploymentContainer.telephonyDeployments.filter(d => d.applicationId === props.applicationId));
        let updatedSections = [...appendedSections];

        const updatePhoneNumberSection = () => {
            const phoneNumberSectionExists = updatedSections.some(section => section.name === "Phone Number");
            const currentAppTelephonyDeployments = telephonyDeploymentContainer.telephonyDeployments.filter(d => d.applicationId === props.applicationId);
            if (currentAppTelephonyDeployments.length > 0) {
                // Remove Phone Number section if telephony deployments exist
                updatedSections = updatedSections.filter(section => section.name !== "Phone Number");
            } else if (applicationType !== "common" && !phoneNumberSectionExists && !isFinishSelected) {
                // Add Phone Number section if it doesn't already exist
                updatedSections.push({
                    id: uuidv4(),
                    name: "Phone Number",
                    isComplete: false,
                    isSelected: false,
                });
            }
        };
        const updateAutoGenerateResponsesSection = () => {
            if (combinedFormSections.length > 0) {
                const allTemplates = props.appliedAppTemplateContainer.state.appliedTemplates;

                // Hide Auto-Generate Responses for AI Ordering and Dental Scheduling — only show for AI Answering.
                const currentAppFlags = props.appContainer.state.currentApp?.featureFlags;
                const isAiOrdering = currentAppFlags?.some(ff => ff.id === FoodOrderingFeatureFlagId);
                const isDentalScheduling = currentAppFlags?.some(ff => ff.id === HealthcareSchedulingFeatureFlagId);
                if (isAiOrdering || isDentalScheduling) {
                    updatedSections = updatedSections.filter(section => section.name !== "Auto-Generate Responses");
                    return;
                }

                // if we have a template form field value that is NOT the associated variable that we should remove it.
                let showSection = true;
                for (const appliedTemplates of allTemplates) {
                    if (appliedTemplates?.templateFormFieldValues?.some(tffv => tffv?.value && tffv?.value !== tffv?.associatedVariable && tffv?.value !== tffv?.defaultValue)) {
                        showSection = false;
                        break;
                    }

                }
                if (!showSection) {
                    updatedSections = updatedSections.filter(section => section.name !== "Auto-Generate Responses");
                } else {
                    const autoGenerateResponsesSectionExists = updatedSections.some(section => section.name === "Auto-Generate Responses");
                    // Add Auto-Generate Responses section if it doesn't already exist
                    if (!autoGenerateResponsesSectionExists && !isFinishSelected) {
                        updatedSections.push({
                            id: uuidv4(),
                            name: "Auto-Generate Responses",
                            isComplete: false,
                            isSelected: true, // Always select it when first created
                        });

                        // Always set this section as selected when created
                        setAutoGenerateFormResponsesSection({
                            id: updatedSections[updatedSections.length - 1].id,
                            name: "Auto-Generate Responses",
                            isComplete: false,
                            isSelected: true,
                        });

                        // Clear any existing currentSection to ensure auto-generate takes priority
                        setCurrentSection(null);
                    }
                }

            }
        };

        updatePhoneNumberSection();
        updateAutoGenerateResponsesSection();
        setAppendedSections(updatedSections);
    }, [
        applicationType,
        props.applicationId,
        telephonyDeploymentContainer.telephonyDeployments,
        loaded,
        isLoadingApplicationType
    ]);

    // Handle admin fields visibility changes and sections with no visible fields
    useEffect(() => {
        if (!currentSection) return;

        const allCombinedSections = getAllCombinedSections();
        const currentSectionStillExists = allCombinedSections.some(s => {
            if (s.sectionType === 'template' && currentSection.appliedTemplateId && currentSection.section) {
                return s.appliedTemplateId === currentSection.appliedTemplateId &&
                    s.section?.id === currentSection.section?.id;
            }
            return false;
        });

        // If current section no longer exists (due to all fields being hidden or admin filter)
        if (!currentSectionStillExists) {
            // Move to the first available section or finish section
            if (allCombinedSections.length > 0) {
                handleNavigateToSection(allCombinedSections[0]);
            } else {
                handleFinishSelected();
            }
        }
    }, [showAdminFields, props.appliedAppTemplateContainer.state.appliedTemplates]);

    // Handle case when showAdminFields changes and there's no current section
    useEffect(() => {
        if (showAdminFields && !currentSection && !isFinishSelected && !telephonyDeploymentSection && !autoGenerateFormResponsesSection) {
            // If admin fields are now shown and we don't have a current section,
            // try to select the first available section (including admin sections)
            const allCombinedSections = getAllCombinedSections();
            if (allCombinedSections.length > 0) {
                handleNavigateToSection(allCombinedSections[0]);
            }
        }
    }, [showAdminFields]);

    // Recalculate incomplete sections whenever applied templates or their values change
    useEffect(() => {
        if (loaded && isFinishSelected) {
            calculateIncompleteSections();
        }
    }, [props.appliedAppTemplateContainer.state.appliedTemplates, loaded, isFinishSelected]);

    const initialLoad = async () => {
        const tasks = [];
        tasks.push(props.appContainer.loadCurrentAppById(props.applicationId));
        tasks.push(props.appliedAppTemplateContainer.loadAppliedTemplates(props.applicationId));
        tasks.push(telephonyDeploymentContainer.getTelephonyDeployments(props.applicationId));
        tasks.push(props.appliedAppTemplateContainer?.getLoadedTemplatesForApp(props.applicationId));
        await Promise.all(tasks);
        setLoaded(true);
    };

    const getTabs = (existingTelephonyDeployment?: boolean) => {
        if ((telephonyDeploymentContainer.telephonyDeployments.length > 0) || existingTelephonyDeployment) {
            const returnArray = [{
                title: "Form",
                icon: formIcon,
                selectedIcon: formIcon
            }, {
                title: "Phone",
                icon: voiceIcon,
                selectedIcon: voiceIcon
            }, {
                title: "Analytics",
                icon: analyticsIcon,
                selectedIcon: analyticsIcon
            }];

            if (props.appContainer.state.currentApp.featureFlags?.some(ff => ff.id === OutboundCallFeatureFlagId)) {
                returnArray.push({
                    title: "Outbound Call",
                    icon: outboundCallIcon,
                    selectedIcon: outboundCallIcon
                });
            }

            if (props.appContainer.state.currentApp.manageMenuApplicationId?.length) {
                returnArray.push({
                    title: "Menu",
                    icon: menuIcon,
                    selectedIcon: menuIcon
                });
            }

            return returnArray;
        } else {
            return [{
                title: "Form",
                icon: formIcon,
                selectedIcon: formIcon
            }];
        }
    };

    const loadTelephonyDeployments = async () => {
        setIsLoadingTelephonyDeployments(true);
        const telephonyDeploymentsResponse = await telephonyDeploymentContainer.getTelephonyDeployments(props.applicationId);
        setTelephonyDeployments(telephonyDeploymentsResponse.data);
        setIsLoadingTelephonyDeployments(false);
    };

    const loadApplicationType = async () => {
        if (!props.appContainer.state.currentApp) return;
        const currentApp = props.appContainer.state.currentApp;
        setApplicationType(currentApp?.allowsTemplating ? "common" : "location");
        setIsLoadingApplicationType(false);
    };

    const startListeningForTraining = (appliedTemplateSyncId?: string) => {
        // Start SparkDeploymentContainer polling to track deployment state
        // This ensures ApplicationItem components show correct training state when navigating back to dashboard
        const app = props.appContainer.state.currentApp;
        const org = props.orgContainer.state.currentOrganization;
        if (app && org) {
            trainingContainer.pollForApplication(app.id, org.id, appliedTemplateSyncId);
        }
    };

    const getVoice = (voice: string) => {
        switch (voice) {
            case female1Voice:
                return "female1";
            case female2Voice:
                return "female2";
            case female3Voice:
                return "female3";
            case female4Voice:
                return "female4";
            case male1Voice:
                return "male1";
            case male2Voice:
                return "male2";
            case male3Voice:
                return "male3";
            case male4Voice:
                return "male4";
            default:
                return "custom";
        }
    };

    const getVoiceString = (voice: string) => {

        let ttsVoice = "";

        switch (voice) {
            case "female1":
                ttsVoice = female1Voice;
                break;
            case "female2":
                ttsVoice = female2Voice;
                break;
            case "female3":
                ttsVoice = female3Voice;
                break;
            case "female4":
                ttsVoice = female4Voice;
                break;
            case "male1":
                ttsVoice = male1Voice;
                break;
            case "male2":
                ttsVoice = male2Voice;
                break;
            case "male3":
                ttsVoice = male3Voice;
                break;
            case "male4":
                ttsVoice = male4Voice;
                break;
            default: {
                // Check named voices from voiceOptions (e.g. "Callie", "Vicky", etc.)
                const namedVoice = voiceOptions.find(v => v.value === voice);
                ttsVoice = namedVoice ? namedVoice.voice : female1Voice;
                break;
            }
        }

        return ttsVoice;

    };

    const handleSubmitTelephonyForm = async (phoneNumber: string, telephonyDeploymentRequest: TelephonyDeploymentRequest) => {
        //find deployment by phone number and locale
        const telephonyDeployment = telephonyDeploymentContainer.telephonyDeployments.find(
            td => td.phoneNumber === phoneNumber && td.locale === telephonyDeploymentRequest.locale
        );

        setIsLoadingTelephonyDeployments(true);

        let ttsProvider = "ElevenLabs";
        let ttsVoice = female1Voice;

        switch (telephonyDeploymentRequest.ttsVoice) {
            case "female1":
                break;
            case "female2":
                ttsVoice = female2Voice;
                break;
            case "female3":
                ttsVoice = female3Voice;
                break;
            case "female4":
                ttsVoice = female4Voice;
                break;
            case "male1":
                ttsVoice = male1Voice;
                break;
            case "male2":
                ttsVoice = male2Voice;
                break;
            case "male3":
                ttsVoice = male3Voice;
                break;
            case "male4":
                ttsVoice = male4Voice;
                break;
            default:
                ttsProvider = telephonyDeployment?.ttsProvider || "ElevenLabs";
                ttsVoice = telephonyDeployment?.ttsVoice || female1Voice;
                break;
        }

        telephonyDeploymentRequest.ttsProvider = ttsProvider;
        telephonyDeploymentRequest.ttsVoice = ttsVoice;

        await telephonyDeploymentContainer.updateTelephonyDeployment(props.applicationId, phoneNumber, telephonyDeploymentRequest);

        await loadTelephonyDeployments();

        setIsLoadingTelephonyDeployments(false);
    };

    const updateSonioxContextForAllTelephonyDeployments = async (sonioxContextJson: string) => {
        setIsLoadingTelephonyDeployments(true);

        try {
            const deploymentsToUpdate = (telephonyDeploymentContainer.telephonyDeployments.length
                ? telephonyDeploymentContainer.telephonyDeployments
                : telephonyDeployments
            ).filter(deployment => deployment.applicationId === props.applicationId);
            const shouldSwitchToSoniox = !!sonioxContextJson.length;

            for (const deployment of deploymentsToUpdate) {
                const telephonyDeploymentRequest: TelephonyDeploymentRequest = {
                    ...deployment,
                    phoneNumberStartsWith: deployment.phoneNumber?.substring(0, 3),
                    sonioxContextJson,
                    asrProvider: shouldSwitchToSoniox ? 'Soniox' : deployment.asrProvider,
                };

                await telephonyDeploymentContainer.updateTelephonyDeployment(props.applicationId, deployment.phoneNumber, telephonyDeploymentRequest);
            }

            await loadTelephonyDeployments();
        } finally {
            setIsLoadingTelephonyDeployments(false);
        }
    };

    const handleHintsAndTermsChange = (value: string) => {
        setSparkHintsAndTermsJson(value);
        setSparkHintsAndTermsTouched(true);
    };

    const getHintsAndTermsValidationError = (value: string) => {
        return getSonioxContextValidationError(value).replace('Soniox context', 'Hints and terms');
    };

    const handleSaveHintsAndTerms = async () => {
        const validationError = getHintsAndTermsValidationError(sparkHintsAndTermsJson);

        if (!!validationError.length) {
            setSparkHintsAndTermsTouched(true);
            return;
        }

        setIsSavingHintsAndTerms(true);

        try {
            const normalizedHintsAndTerms = normalizeSonioxContextJson(sparkHintsAndTermsJson);
            await updateSonioxContextForAllTelephonyDeployments(normalizedHintsAndTerms);
            setSparkHintsAndTermsJson(normalizedHintsAndTerms);
            setSparkHintsAndTermsTouched(false);
        } finally {
            setIsSavingHintsAndTerms(false);
        }
    };

    const getCurrentAppliedTemplate = () => {
        if (currentSection?.appliedTemplateId?.length) {
            return props.appliedAppTemplateContainer.state.appliedTemplates?.find(at => at.id == currentSection.appliedTemplateId);
        } else {
            return null;
        }
    };

    // Helper function to get all combined sections - used by multiple functions for consistency
    const getAllCombinedSections = () => {
        return combineSections({
            sections: combinedFormSections ?? [],
            appendedSections: appendedSections,
            showAdminFields,
            importedFormFields,
            appliedAppTemplateContainer: props.appliedAppTemplateContainer
        });
    };

    const getCurrentSectionIndex = () => {
        const allCombinedSections = getAllCombinedSections();

        if (!currentSection) {
            // Check if auto-generate section is selected
            if (autoGenerateFormResponsesSection && autoGenerateFormResponsesSection.isSelected) {
                return allCombinedSections.findIndex(section =>
                    section.sectionType === 'auto-generate' && section.name === "Auto-Generate Responses"
                );
            }
            // Check if telephony section is selected
            if (telephonyDeploymentSection && telephonyDeploymentSection.isSelected) {
                return allCombinedSections.findIndex(section =>
                    section.sectionType === 'appended' && section.name === "Phone Number"
                );
            }
            return -1;
        }

        // Find the index using the unified utility
        return findActiveSectionIndex(allCombinedSections, currentSection);
    };

    const handleToggleExpandLeft = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, expanded: boolean) => {
        setIsLeftExpanded(expanded);
        localStorage.setItem("contentMenu", expanded?.toString());
        e?.stopPropagation();
    };

    const calculateIncompleteSections = () => {
        const incompleteFormSections = [];
        // Always use the container's getIncompleteSections method for consistency
        props.appliedAppTemplateContainer.state.appliedTemplates?.forEach((appliedTemplate) => {
            const incompleteSections = props.appliedAppTemplateContainer.getIncompleteSections(appliedTemplate) ?? [];
            incompleteSections.forEach(section => {
                // Attach the applied template ID to help identify which template this section belongs to
                incompleteFormSections.push({ ...section, appliedTemplateId: appliedTemplate.id, appliedTemplateName: appliedTemplate.name })
            })
        });
        // Note: Phone Number and Auto-Generate sections are optional and should not block finishing
        // They are appended sections that users can skip
        setIncompleteSections(incompleteFormSections);
    };

    const handleFinishSelected = () => {
        setIsFinishSelected(true);
        calculateIncompleteSections();
        setCurrentSection(null);
        setTelephonyDeploymentSection(null);
        setAutoGenerateFormResponsesSection(null);
        if (appendedSections.length > 0) {
            const newAppendedSections = appendedSections.filter(section => !sectionsToRemove.includes(section.id));
            setAppendedSections(newAppendedSections.map(s => ({ ...s, isSelected: false })));
        }
    };

    // Unified navigation handler that works with CombinedSection
    const handleNavigateToSection = (section: CombinedSection) => {

        // Reset all section states first
        setCurrentSection(null);
        setAutoGenerateFormResponsesSection(null);
        setTelephonyDeploymentSection(null);

        if (section.sectionType === 'template') {
            // Convert CombinedSection back to SparkTemplateFormSectionModel
            const templateSection: SparkTemplateFormSectionModel = {
                appliedTemplateId: section.appliedTemplateId!,
                section: section.section
            };
            setCurrentSection(templateSection);
        } else if (section.sectionType === 'auto-generate') {
            // Find the actual auto-generate section
            const autoGenerateSection = appendedSections?.find(s => s.name === "Auto-Generate Responses");
            if (autoGenerateSection) {
                setAutoGenerateFormResponsesSection({ ...autoGenerateSection, isSelected: true });
            }
        } else if (section.sectionType === 'appended') {
            // For appended sections, the name is directly on the section object
            if (section.name === "Phone Number") {
                // Find the actual telephony section
                const telephonySection = appendedSections?.find(s => s.name === "Phone Number");
                if (telephonySection) {
                    setTelephonyDeploymentSection({ ...telephonySection, isSelected: true });
                }
            }
        }

        // Reset appended sections selection state
        if (appendedSections.length > 0) {
            setAppendedSections(appendedSections.map(s => ({ ...s, isSelected: false })));
        }

        // Clear finish selection
        setIsFinishSelected(false);
    };

    const handleNavigateToField = (fieldId: string) => {
        const targetSection = getSections().find(s =>
            s.section?.templateFormFields?.some((f: any) => f.id === fieldId)
        );
        if (targetSection) {
            handleSectionSelected(targetSection.section, targetSection.appliedTemplateId);
            setHighlightedFieldId(fieldId);
        }
    };

    useEffect(() => {
        if (!highlightedFieldId) return;
        const element = document.getElementById(highlightedFieldId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setHighlightedFieldId(null);
        }
    }, [highlightedFieldId, currentSection]);

    const handleMultilingualEnabled = () => {
        const appliedTemplates = props.appliedAppTemplateContainer.getLoadedTemplatesForApp(props.applicationId);
        if (!appliedTemplates?.length) return;
        const appliedTemplate = appliedTemplates[0];
        const currentValues = [...(appliedTemplate.templateFormFieldValues ?? [])];
        const existingIndex = currentValues.findIndex(v => v.associatedVariable === '{Multilingual}');
        if (existingIndex !== -1) {
            currentValues[existingIndex] = { ...currentValues[existingIndex], value: 'true' };
        } else {
            currentValues.push({ associatedVariable: '{Multilingual}', value: 'true' } as any);
        }
        props.appliedAppTemplateContainer.finishFormSection(appliedTemplate.id, { fieldValues: currentValues });
    };

    // Accept latest form values as argument and store before navigating
    const handleNextSection = (latestFormValues: TemplateFormFieldValueModel[]) => {
        if (latestFormValues) {
            // Store latest values in applied template (or state)
            const currentAppliedTemplate = getCurrentAppliedTemplate();
            if (currentAppliedTemplate) {
                props.appliedAppTemplateContainer.finishFormSection(currentAppliedTemplate.id, { fieldValues: latestFormValues });
            }
        }
        const allCombinedSections = getAllCombinedSections();
        const currentIndex = getCurrentSectionIndex();
        const nextTarget = getNextSection(allCombinedSections, currentIndex);
        if (nextTarget === 'finish') {
            handleFinishSelected();
        } else if (nextTarget) {
            handleNavigateToSection(nextTarget);
        } else {
            handleFinishSelected();
        }
    };

    const handlePreviousSection = async () => {

        const allCombinedSections = getAllCombinedSections();
        let currentDynamicSectionName: string;
        if (currentSection?.section?.name) {
            currentDynamicSectionName = currentSection?.section?.name
        }
        const currentIndex = getCurrentSectionIndex();
        const previousTarget = getPreviousSection(allCombinedSections, currentIndex, isFinishSelected);

        if (areNoTemplateFormSections) {
            setIsFinishSelected(false);
            setCurrentSection(null);
            setAreNoTemplateFormSections(false);
            return;
        }

        if (previousTarget === 'start') {
            // Clear everything to go to start
            setIsFinishSelected(false);
            setCurrentSection(null);
            setAutoGenerateFormResponsesSection(null);
            setTelephonyDeploymentSection(null);
        } else if (previousTarget) {
            handleNavigateToSection(previousTarget);
        } else {
            setCurrentSection(null);
            setAutoGenerateFormResponsesSection(null);
            setTelephonyDeploymentSection(null);
        }

        if (currentDynamicSectionName) {
            await props.appliedAppTemplateContainer.removeDynamicFormSection(currentSection.appliedTemplateId, currentDynamicSectionName);
        }
        setAreNoTemplateFormSections(false);
    };

    const handleRemoveSection = (sectionToRemove: AppendedSection) => {
        const sectionToRemoveIndex = appendedSections.findIndex(section => section.id === sectionToRemove.id);
        const appendedSectionsWithoutRemovedSection = [
            ...appendedSections.slice(0, sectionToRemoveIndex),
            ...appendedSections.slice(sectionToRemoveIndex + 1)
        ];
        setAppendedSections(appendedSectionsWithoutRemovedSection);
        handleNextSection(appendedSectionsWithoutRemovedSection);
        setSectionsToRemove([...sectionsToRemove, sectionToRemove.id]);
    };

    // Unified section selection handler that works with both old and new interfaces
    const handleUnifiedSectionSelect = (sectionData: any) => {

        // Check if this is already a CombinedSection
        if (sectionData.sectionType) {
            handleNavigateToSection(sectionData);
            return;
        }

        // Handle legacy section selection
        if (sectionData.section) {
            // This is a template section
            const allCombinedSections = getAllCombinedSections();
            const matchingSection = allCombinedSections.find(s =>
                s.sectionType === 'template' &&
                s.section?.title === sectionData.section?.title
            );
            if (matchingSection) {
                handleNavigateToSection(matchingSection);
            }
        } else if (sectionData.name) {
            // This is an appended section
            const allCombinedSections = getAllCombinedSections();
            const matchingSection = allCombinedSections.find(s =>
                (s.sectionType === 'auto-generate' || s.sectionType === 'appended') &&
                s.name === sectionData.name
            );
            if (matchingSection) {
                handleNavigateToSection(matchingSection);
            }
        }
    };

    // Legacy handlers for backward compatibility
    const handleSectionSelected = (section: TemplateFormSectionModel, appliedTemplateId: string) => {
        handleUnifiedSectionSelect({ section, appliedTemplateId });
    };

    const handleAppendedSectionSelected = (section: AppendedSection) => {
        handleUnifiedSectionSelect(section);
    };

    const removeSectionFromIncompleteSections = (section: AppendedSection) => {
        setIncompleteSections([
            ...incompleteSections.filter(incompleteSection => incompleteSection?.id !== section.id),
            section
        ]);
    };

    const toggleCloseModal = () => {
        setCloseModalIsOpen(!closeModalIsOpen);
    };

    const handleClose = () => {
        toggleCloseModal();
    };

    const handleInsertDynamicFormSection = async (dynamicSection: TemplateFormSectionModel) => {
        const newSection = await props.appliedAppTemplateContainer.insertDynamicFormSection(getCurrentAppliedTemplate().id, dynamicSection, currentSection.section)
        setIsFinishSelected(false);
        setCurrentSection({
            appliedTemplateId: getCurrentAppliedTemplate().id,
            section: newSection
        });
    };

    const handleTransferPhoneNumber = async () => {
        if (!selectedTelephonyDeploymentNumber || !targetApplicationName) {
            return;
        }
        const app = applicationsList.find(app => app.name === targetApplicationName);
        const transferResult = await telephonyDeploymentContainer.moveTelephonyDeployment(props.applicationId, selectedTelephonyDeploymentNumber, app.id);
        if (transferResult.resultType === "Ok") {
            setSelectedTelephonyDeploymentNumber("");
            setTargetApplicationName("");
            //remove the transfered phone number from the telephonyDeployments list
            const updatedTelephonyDeployments = telephonyDeployments.filter(td => td.phoneNumber !== selectedTelephonyDeploymentNumber);
            setTelephonyDeployments(updatedTelephonyDeployments);
        }
    }

    const getSections = (importedFormFields?: TemplateFormFieldValueModel[]) => {
        const allCombinedSections = getAllCombinedSections();
        return getTemplateSectionsOnly(allCombinedSections);
    };

    const getPageCount = () => {
        const allCombinedSections = getAllCombinedSections();
        return utilGetPageCount(allCombinedSections);
    };

    const getCurrentPageNumber = () => {
        const allCombinedSections = getAllCombinedSections();
        const currentIndex = getCurrentSectionIndex();
        return utilGetCurrentPageNumber(allCombinedSections, currentIndex, isFinishSelected);
    };

    const getDefaultTemplateValues = () => {
        const templateValues = [];
        combinedFormSections?.forEach(formSection => {
            formSection?.section?.templateFormFields?.forEach(formField => {
                if (formField?.defaultValue) {
                    const fieldValue: TemplateFormFieldValueModel = {
                        value: formField?.defaultValue,
                        fieldType: formField?.fieldType,
                        tip: formField?.tip,
                        title: formField?.title,
                        label: formField?.label,
                        defaultValue: formField?.defaultValue,
                        associatedVariable: formField?.associatedVariable,
                        placeholder: formField?.placeholder,
                        templateFormFieldId: formField?.id
                    };
                    templateValues.push(fieldValue);
                }
            })
        })
        return templateValues;
    };

    const setPageErrorText = (text: string) => {
        setPhoneNumberDeploymentErrorText(text);
    };

    const renderMenu = () => {
        return (
            <>
                <PanelHeaderContainer className={stepHeaderWrapper}>
                    <div className="page-indicator-container">
                        <p>Step {getCurrentPageNumber()} of {getPageCount()}</p>
                    </div>
                </PanelHeaderContainer>

                <AppliedAppTemplateSectionMenu
                    handleToggleExpandLeft={handleToggleExpandLeft}
                    fileImportErrors={fileImportErrors}
                    setFileImportErrors={setFileImportErrors}
                    importedFormFields={importedFormFields}
                    setImportedFormFields={setImportedFormFields}
                    history={props.history}
                    applicationId={props.applicationId}
                    appContainer={props.appContainer}
                    appliedAppTemplateContainer={props.appliedAppTemplateContainer}
                    activeSection={currentSection ? { appliedTemplateId: currentSection.appliedTemplateId, section: currentSection.section, isComplete: props.appliedAppTemplateContainer.getIsSectionOfCurrentComplete(getCurrentAppliedTemplate(), currentSection.section) } : (telephonyDeploymentSection || autoGenerateFormResponsesSection)}
                    sections={getSections()}
                    isFinishSelected={isFinishSelected}
                    onFinishSelect={handleFinishSelected}
                    onSectionSelect={handleSectionSelected}
                    onAppendedSectionSelect={handleAppendedSectionSelected}
                    onFieldSelect={handleNavigateToField}
                    onStartSelect={null}
                    hideStart={true}
                    appendedSections={appendedSections}
                    templateConfigContainer={props.templateConfigContainer}
                    orgContainer={props.orgContainer}
                    appliedAppTemplateId={props.appliedAppTemplateId}
                    showAdminFields={showAdminFields}
                    setShowAdminFields={setShowAdminFields}
                    fieldValidationErrors={fieldValidationErrors}
                />

            </>);
    };

    // Group deployments by phone number to not show duplicates with different locales
    const groupDeploymentsByPhoneNumber = () => {
        const grouped: { [phoneNumber: string]: TelephonyDeploymentResponse[] } = {};

        telephonyDeployments?.forEach(deployment => {
            const phoneNumber = deployment.phoneNumber;
            if (!grouped[phoneNumber]) {
                grouped[phoneNumber] = [];
            }
            grouped[phoneNumber].push(deployment);
        });

        return grouped;
    };

    const getUniquePhoneNumbers = () => {
        const grouped = groupDeploymentsByPhoneNumber();
        return Object.keys(grouped).map(phoneNumber => ({
            phoneNumber,
            deployment: grouped[phoneNumber][0], // Show the first deployment
            allDeployments: grouped[phoneNumber],
            localeCount: grouped[phoneNumber].length
        }));
    };

    const renderTelephonyDetails = () => {
        const currentApp = props.appContainer.state.currentApp;
        const appVertical = currentApp?.featureFlags?.some(ff => ff.id === FoodOrderingFeatureFlagId)
            ? 'ai-ordering'
            : currentApp?.featureFlags?.some(ff => ff.id === HealthcareSchedulingFeatureFlagId)
                ? 'dental-scheduling'
                : '';
        return (
            <ScrollablePanelBody className={paddedBody}>
                <SettingsCard title="Voice">
                    {isLoadingTelephonyDeployments || telephonyDeploymentContainer.isLoading ? <Loader /> :
                        telephonyDeployments.length > 0 ? (
                            <>
                                {getUniquePhoneNumbers().map(({ phoneNumber, deployment, allDeployments, localeCount }, telephonyDeploymentIndex) => (
                                    <ContentCollapsingSection
                                        key={phoneNumber}
                                        icon={voiceIconBlue}
                                        title={
                                            deployment.virtualNumber
                                                ? (deployment.name ? `${deployment.name}: ${deployment.virtualNumber}` : deployment.virtualNumber)
                                                : (deployment.name ? `${deployment.name}: ` : '') +
                                                formatPhoneNumber(deployment.phoneNumber) +
                                                (deployment.platform ? ` (${deployment.platform})` : '') +
                                                (localeCount > 1 ? ` (${localeCount} locales)` : '')
                                        }
                                        isCollapsedByDefault={telephonyDeploymentIndex === 0 ? false : true}
                                        className={collapsedSection}
                                    >
                                        <SparkTelephonyDetailsForm
                                            loadTelephonyDeployments={loadTelephonyDeployments}
                                            selectedTelephonyDeployment={deployment}
                                            allTelephonyDeployments={allDeployments}
                                            isLoadingTelephonyDeployments={isLoadingTelephonyDeployments}
                                            handleSubmitTelephonyForm={handleSubmitTelephonyForm}
                                            applicationId={props.applicationId}
                                            createTelephonyDeployment={telephonyDeploymentContainer.createTelephonyDeployment}
                                            orgName={props.orgContainer.state.currentOrganization?.name ?? ''}
                                            appName={props.appContainer.state.currentApp?.name ?? ''}
                                            assistantType={appVertical}
                                            onMultilingualEnabled={handleMultilingualEnabled}
                                        />
                                    </ContentCollapsingSection>
                                ))}
                                <HintsAndTermsPanel>
                                    <SonioxContextEditor
                                        name="sparkHintsAndTermsJson"
                                        title="General Hints and Terms"
                                        value={sparkHintsAndTermsJson}
                                        onChange={handleHintsAndTermsChange}
                                        onBlur={() => setSparkHintsAndTermsTouched(true)}
                                        onTouch={() => setSparkHintsAndTermsTouched(true)}
                                        description=""
                                        emptyGeneralHintsText="No general hints yet. Add a row to include common context keys."
                                        showPreview={false}
                                        showFieldError={false}
                                        error={sparkHintsAndTermsTouched ? getHintsAndTermsValidationError(sparkHintsAndTermsJson) : ''}
                                    />
                                    <HintsAndTermsSaveRow>
                                        <Button
                                            disabled={isSavingHintsAndTerms || !!getHintsAndTermsValidationError(sparkHintsAndTermsJson).length}
                                            loading={isSavingHintsAndTerms}
                                            themes={["primary-small"]}
                                            text="Save Hints and Terms"
                                            type="button"
                                            onClick={handleSaveHintsAndTerms}
                                        />
                                    </HintsAndTermsSaveRow>
                                </HintsAndTermsPanel>
                            </>
                        ) :
                            (
                                <EmptyView
                                    imageStyle={emptyViewImageStyle}
                                    title="We couldn't find any telephony deployments for this assistant."
                                    description="Configure a phone number to enable voice features."
                                />
                            )}
                    <ContentCollapsingSection
                        title="Move Phone Number"
                        icon={moveIcon}
                        isCollapsedByDefault={true}
                        className={collapsedSection}
                    >
                        {telephonyDeployments.length > 0 && renderMovePhoneNumber()}
                    </ContentCollapsingSection>
                </SettingsCard>
            </ScrollablePanelBody>
        )
    };

    const renderMovePhoneNumber = () => {
        return (
            <>
                <MoveNumberTitleSection>
                    <h1>Move Phone Number</h1>
                    <p>Transfer number from this application to another application</p>
                </MoveNumberTitleSection>
                <MovePhoneNumberFieldsWrapper>
                    <SelectField
                        useForm={false}
                        useFormTheme={true}
                        label='Assistant Number'
                        options={
                            telephonyDeployments.map((x: TelephonyDeploymentResponse) => ({ value: x.phoneNumber, label: x?.name ? `${x.phoneNumber} - ${x.name}` : x.phoneNumber }))
                        }
                        onChange={(e) => setSelectedTelephonyDeploymentNumber(e?.value)}
                        placeholder='Phone number'
                        value={selectedTelephonyDeploymentNumber}
                        clearable={false}
                        className='assistantNumberSelect'
                    />
                    <h3>To</h3>
                    <SelectField
                        useForm={false}
                        useFormTheme={true}
                        label='Target Application'
                        options={
                            applicationsList.map((app) => ({ value: app.name, label: app.name }))
                        }
                        onChange={(e) => setTargetApplicationName(e?.value)}
                        placeholder='Select The Target Application'
                        value={targetApplicationName}
                        clearable={false}
                        className='assistantNumberSelect'
                    />
                </MovePhoneNumberFieldsWrapper>
                <Button themes={["action-item"]} text='Move number' className={transferButtonStyle} onClick={handleTransferPhoneNumber} />
            </>
        )
    }

    const renderModuleFormBody = () => {
        const { isLoading } = props.appliedAppTemplateContainer.state;
        const currentAppliedTemplate = getCurrentAppliedTemplate();
        const defaultValues = getDefaultTemplateValues();
        if (currentAppliedTemplate != null && (currentAppliedTemplate?.templateFormFieldValues == null || currentAppliedTemplate?.templateFormFieldValues?.length === 0))
            currentAppliedTemplate.templateFormFieldValues = defaultValues;

        if (isLoading)
            return <Loader />

        if (!currentSection && !telephonyDeploymentSection && !autoGenerateFormResponsesSection && !isFinishSelected) {
            return <EmptyView
                imageStyle={emptyViewImageStyle}
                title="It's quiet in here!"
                description="It doesn't look like your assistant has any content. Reach out to your administrator to get set up."
            />
        }

        if (currentSection)
            return <UpdateAppliedAppTemplateForm
                calculateIncompleteSections={calculateIncompleteSections}
                importedFormFields={importedFormFields}
                setImportedFormFields={setImportedFormFields}
                currentSectionIndex={getCurrentSectionIndex()}
                history={props.history}
                applicationId={props.applicationId}
                appContainer={props.appContainer}
                appliedAppTemplateContainer={props.appliedAppTemplateContainer}
                appliedAppValues={getCurrentAppliedTemplate()?.templateFormFieldValues ?? []}
                appliedAppTemplate={getCurrentAppliedTemplate()}
                templateSection={currentSection.section}
                insertDynamicFormSection={handleInsertDynamicFormSection}
                onNext={handleNextSection}
                onPrevious={handlePreviousSection}
                showAdminFields={showAdminFields}
                onFieldValidationChange={handleFieldValidationChange}
            />

        if (telephonyDeploymentSection) {
            const currentApp = props.appContainer.state.currentApp;
            const appVertical = currentApp?.featureFlags?.some(ff => ff.id === FoodOrderingFeatureFlagId)
                ? 'ai-ordering'
                : currentApp?.featureFlags?.some(ff => ff.id === HealthcareSchedulingFeatureFlagId)
                    ? 'dental-scheduling'
                    : '';
            return <SparkTelephonyDeploymentForm
                getVoiceString={getVoiceString}
                incompleteSections={incompleteSections}
                setIncompleteSections={setIncompleteSections}
                setAppendedSections={setAppendedSections}
                appendedSections={appendedSections}
                telephonyDeploymentSection={telephonyDeploymentSection}
                voiceOptions={voiceOptions}
                handlePreviousSection={handlePreviousSection}
                handleNextSection={() => handleNextSection([])}
                createTelephonyDeployment={telephonyDeploymentContainer.createTelephonyDeployment}
                applicationId={props.applicationId}
                environmentId={props.applicationEnvironmentsContainer.state?.environments[0]?.id}
                clearTelephonyDeploymentErrors={telephonyDeploymentContainer.clearErrors}
                setPageErrorText={setPageErrorText}
                phoneNumberDeploymentErrorText={phoneNumberDeploymentErrorText}
                setPhoneNumberDeploymentErrorText={setPhoneNumberDeploymentErrorText}
                getTabs={getTabs}
                setTabs={setTabs}
                loadTelephonyDeployments={loadTelephonyDeployments}
                handleRemoveSection={handleRemoveSection}
                removeSectionFromIncompleteSections={removeSectionFromIncompleteSections}
                assistantType={appVertical}
                orgName={props.orgContainer.state.currentOrganization?.name ?? ''}
                appName={currentApp?.name ?? ''}
                onMultilingualEnabled={handleMultilingualEnabled}
            />
        }

        if (autoGenerateFormResponsesSection) {
            return <AutoGenerateFormFieldResponsesForm
                applicationId={props.applicationId}
                handlePreviousSection={handlePreviousSection}
                handleNextSection={() => handleNextSection([])}
                mediaContainer={props.mediaContainer}
                appliedAppTemplateContainer={props.appliedAppTemplateContainer}
                appendedSections={appendedSections}
                setAppendedSections={setAppendedSections}
                incompleteSections={incompleteSections}
                setIncompleteSections={setIncompleteSections}
                autoGenerateFormResponsesSection={autoGenerateFormResponsesSection}
                handleRemoveSection={handleRemoveSection}
                removeSectionFromIncompleteSections={removeSectionFromIncompleteSections}
                setIsLoading={(value) => setIsLoadingAutoGenerateAnswer(value)}
                isLoading={isLoadingAutoGenerateAnswer}
            />
        }

        if (isFinishSelected) {
            return <AppliedAppTemplateReviewForm
                history={props.history}
                applicationId={props.applicationId}
                appContainer={props.appContainer}
                orgContainer={props.orgContainer}
                appliedAppTemplateContainer={props.appliedAppTemplateContainer}
                appliedTemplates={props.appliedAppTemplateContainer.state.appliedTemplates}
                incompleteSections={incompleteSections}
                afterSubmit={startListeningForTraining}
                applicationEnvironmentsContainer={props.applicationEnvironmentsContainer}
                applicationType={applicationType}
                phoneNumberDeploymentErrorText={phoneNumberDeploymentErrorText}
                clearTelephonyDeploymentErrors={telephonyDeploymentContainer.clearErrors}
                loadTelephonyDeployments={loadTelephonyDeployments}
                isLoadingTelephonyDeployments={isLoadingTelephonyDeployments}
                calculateIncompleteSections={calculateIncompleteSections}
                fieldValidationErrors={fieldValidationErrors}
                onSectionSelect={handleSectionSelected}
                onMenuPublished={menuSyncContainer.startMenuSync}
            />
        } else {
            return null;
        };

    };

    const handleTabSelection = (index: number, last: number) => {
        if (index == last) return;
        const urlStart = "/v/apps/" + props.applicationId;
        const hasOutboundCall = props.appContainer.state.currentApp.featureFlags?.some(ff => ff.id === OutboundCallFeatureFlagId);
        const hasMenu = props.appContainer.state.currentApp.manageMenuApplicationId?.length;

        switch (index) {
            case 0:
                props.history.push(urlStart)
                break;
            case 1:
                props.history.push(urlStart + "/voice")
                break;
            case 2:
                props.history.push(urlStart + "/analytics")
                break;
            case 3:
                if (hasOutboundCall) {
                    props.history.push(urlStart + "/outboundCall")
                } else if (hasMenu) {
                    props.history.push(urlStart + "/menu")
                }
                break;
            case 4:
                props.history.push(urlStart + "/menu")
                break;
        }
    };

    const getSelectedIndex = () => {
        const url = props.history.location.pathname;
        const hasOutboundCall = props.appContainer.state?.currentApp?.featureFlags?.some(ff => ff.id === OutboundCallFeatureFlagId);

        if (url.includes("/voice")) {
            return 1;
        } else if (url.includes("/analytics")) {
            return 2;
        } else if (url.includes("/outboundCall") && hasOutboundCall) {
            return 3;
        } else if (url.includes("/menu")) {
            return hasOutboundCall ? 4 : 3;
        }
        return 0;
    };

    const renderFormTabPanel = () => {
        return (
            <TabPanel>
                <PanelContainer className={containerStyle}>
                    {(currentSection || telephonyDeploymentSection || autoGenerateFormResponsesSection || isFinishSelected) &&
                        <MenuWrapper className={isLeftExpanded ? "expanded" : "collapsed"}>
                            <div className={"fixed-wrapper"}>
                                <CollapsingPanel
                                    isCollapsed={!isLeftExpanded}
                                    collapsedView={
                                        <CollapsedMenuPanel
                                            onExpand={(e) => handleToggleExpandLeft(e, true)}
                                            expandedViewRender={renderMenu}
                                        />
                                    }
                                    expandedView={
                                        <ExpandedMenuPanel
                                            onCollapse={(e) => handleToggleExpandLeft(e, false)}
                                            expandedViewRender={renderMenu}
                                            minimizedDrawer={isMobile}
                                        />
                                    } />
                            </div>
                        </MenuWrapper>
                    }
                    <PanelContainer className={isLeftExpanded ? expandedMenuFormBodyStyle : collapsedMenuFormBodyStyle}>
                        <div className="form-wrapper">
                            {renderModuleFormBody()}
                        </div>
                    </PanelContainer>
                </PanelContainer>
                <PageError errors={props.appliedAppTemplateContainer?.state?.errors} onClear={() => props.appliedAppTemplateContainer?.clearErrors()} />
                <PageError errors={fileImportErrors} onClear={() => setFileImportErrors([])} />
            </TabPanel>

        );
    }

    const renderMenuTab = () => {
        return (<TabPanel>
            {menuSyncing ? <EditControlPanel onClick={(e) => e.stopPropagation()} /> : <></>}
            {menuSyncing ?
                <StatusIndicator
                    state={"loading"}
                    failedMessage=''
                    loadingMessage='Training live assistant with updated menu'
                    successMessage=''
                    isClosable={false}
                    onClose={() => { }}
                    onAcceptFailure={() => { }}
                />
                :
                <></>
            }
            <ScrollablePanelBody className={menuSyncing ? blurComponent : ""}>
                <Route path="/v/apps/:applicationId/menu/item/:id" exact
                    render={() =>
                        <ApplicationMenuItemManager
                            application={props.appContainer.state.currentApp}
                            history={props.history}
                            orgId={props.orgContainer.state.currentOrganization.id} />
                    } />
                <Route path="/v/apps/:applicationId/menu" exact
                    render={() =>
                        <MenuManagement
                            application={props.appContainer.state.currentApp}
                            history={props.history}
                            selectedCategoryIndex={selectedMenuCategoryIndex}
                            setSelectedCategoryIndex={setSelectedMenuCategoryIndex}
                            orgId={props.orgContainer.state.currentOrganization.id}
                        />
                    } />

            </ScrollablePanelBody>
        </TabPanel>)
    }

    const renderOutboundCallTab = () => {
        // Only render if feature flag is present
        if (!props.appContainer.state.currentApp.featureFlags?.some(ff => ff.id === OutboundCallFeatureFlagId)) {
            return null;
        }

        return (
            <TabPanel>
                <Route path="/v/apps/:applicationId/outboundCall" exact
                    render={() =>
                        <OutboundCall
                            application={props.appContainer.state.currentApp}
                            history={props.history}
                        />
                    } />
            </TabPanel>
        )
    }

    if (isLoadingApplicationType || !loaded) return <Loader />;
    return (
        <FullPagePanel className={containerStyle}>
            {!(applicationType === "common") ?
                <FullPageTabbedPanel tabs={tabs}
                    onTabSelected={handleTabSelection}
                    selectedIndex={selectedTab}
                    leftRender={() => {
                        const path = `${props?.history?.location?.pathname ?? ""}`;
                        if (path.toLowerCase()?.includes("menu/item"))
                            return undefined;
                        return <>
                            <BackButton onClick={props.history.location.pathname === `/v/apps/${props.applicationId}` ? handleClose : () => props.history.push(`/`)} />
                        </>
                    }}
                    titleRender={() => <HeaderTitleView text={props.appContainer?.state?.currentApp?.name} />
                    }
                    rightRender={() =>
                        <>
                            <HeaderSeparator />
                            <ProfileMenu />
                        </>
                    }>
                    {renderFormTabPanel()}
                    <TabPanel>
                        <ScrollablePanelBody>
                            {renderTelephonyDetails()}
                        </ScrollablePanelBody>
                    </TabPanel>
                    <TabPanel>
                        <ApplicationAnalytics
                            application={props.appContainer.state.currentApp}
                            facetContainer={props.facetContainer}
                            history={props.history}
                            organizationId={props.orgContainer.state.currentOrganization?.id}
                        />
                    </TabPanel>
                    {renderOutboundCallTab()}
                    {renderMenuTab()}
                </FullPageTabbedPanel>
                :
                <FullPageTabbedPanel tabs={[{
                    title: "Form",
                    icon: formIcon,
                    selectedIcon: formIcon
                }]}
                    onTabSelected={handleTabSelection}
                    selectedIndex={selectedTab}
                    leftRender={() => {
                        const path = `${props?.history?.location?.pathname ?? ""}`;
                        if (path.toLowerCase()?.includes("menu/item"))
                            return undefined;
                        return <>
                            <BackButton onClick={props.history.location.pathname === `/v/apps/${props.applicationId}` ? handleClose : () => props.history.push(`/`)} />
                        </>

                    }}
                    titleRender={() => <HeaderTitleView text={props.appContainer?.state?.currentApp?.name} />
                    }
                    rightRender={() =>
                        <>
                            <HeaderSeparator />
                            <ProfileMenu />
                        </>
                    }>
                    {renderFormTabPanel()}
                </FullPageTabbedPanel>
            }
            {
                closeModalIsOpen &&
                <StyledConfirmationDialog
                    title={`Confirm Close`}
                    deleteText="Yes, Close"
                    onClose={toggleCloseModal}
                    onConfirm={() => props.history.push(`/`)}>
                    <WarningConfirmation
                        text={`Are you sure you want to close this form? Any unsaved changes will be lost.`}
                    />
                </StyledConfirmationDialog>
            }
        </FullPagePanel>
    );
}

const StyledConfirmationDialog = styled(ConfirmationDialog)``;

const collapsedSection = css`
    margin: 0 -32px;
    *.card-title-container {
        padding: 24px 24px 24px 40px;
    }
    ${breakpoint_small} {
        margin: 0 -16px;
    }
`;

const HintsAndTermsPanel = styled.div`
    margin: 0 -32px 24px -32px;
    padding: 24px 40px 8px 40px;
    border-bottom: 1px solid ${color_shades_dark};
    ${breakpoint_small} {
        margin: 0 -16px 24px -16px;
        padding: 24px 16px 8px 16px;
    }
`;

const HintsAndTermsSaveRow = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const emptyViewImageStyle = css`
    ${breakpoint_small} {
        height: 350px;
        width: 350px;
    }
`;

const stepHeaderWrapper = css`
    display: flex;
    justify-content: left;
    align-items: center;
`;

const containerStyle = css`
    background: ${color_variants_main_bg};
    .form-wrapper {
        flex: 1;
    }
    .empty-indicator {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .page-indicator-container {
        background: ${color_shades_lighter};
        border: 1px solid ${color_shades_dark};
        box-sizing: border-box;
        border-radius: 4px;
        margin: 0 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 16px;
    }
`;

const collapsedMenuFormBodyStyle = css`
    border-right: 1px solid ${color_shades_dark};
    box-sizing: border-box;
    .scrollable-body {       
        padding-bottom: 56px;
    }
`;

const expandedMenuFormBodyStyle = css`
    border-right: 1px solid ${color_shades_dark};
    box-sizing: border-box;
    .scrollable-body {       
        padding-bottom: 56px;
    }
    ${breakpoint_small} {
        display: none;
    }
`;

const paddedBody = css`
    padding: 32px;
    margin-bottom: 48px;
`;

const MenuWrapper = styled.div`
    z-index: 2;
    bottom: 0;
    position: relative;
    &.collapsed {
        width: 80px;
        .fixed-wrapper {
            width: 80px;
        }
    }
    &.expanded {
        width: 288px; 
        .fixed-wrapper {
            width: 288px;
        }
    }
    .fixed-wrapper {
        position: fixed;
        bottom: 0;
        height: calc(100vh - 80px);
        background: white;
        border-right: 1px solid ${color_shades_dark};
        box-sizing: border-box;
    }
    ${breakpoint_small} {
        &.collapsed {
            width: 0;
            .fixed-wrapper {
                width: 0;
            }
        }
        &.expanded {
            width: 288px; 
            .fixed-wrapper {
                width: 100px;
            }
        }
        .fixed-wrapper {
            position: fixed;
            bottom: 0;
            height: calc(100vh - 80px);
            background: white;
            border-right: 1px solid ${color_shades_dark};
            box-sizing: border-box;
        }
    }
`;

const EditControlPanel = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    filter: blur(2px);
`;

const blurComponent = css`
    filter: blur(2px);
`;

const MovePhoneNumberFieldsWrapper = styled.div`
    width: 100%;
    align-items: center;
    display: flex;
    margin-top: 20px;
    h3 {
        margin: 0 20px;
    } 
    .assistantNumberSelect{
        width: 100%;
    }
    
`;

const MoveNumberTitleSection = styled.div`
    h1 {
        font-size: 18px;
        font-weight: 500;
    }

    p {
        font-size: 14px;
        margin-top: 5px;
        opacity: 0.6;
    }
`;

const transferButtonStyle = css`
    margin: 0 0 20px 0px;
    width: 200px;
    font-size: 15px;
`;

export default ApplicationManagerContent; 
